import script from "./ConfirmationsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationsSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationsSection.vue?vue&type=style&index=0&id=1b2f686d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2f686d"]])

export default __exports__